import React from 'react';
import TeacherGuide from '../components/teacher_guide/teacher_guide.jsx';

export default (props) => (
  <TeacherGuide {...props} />
);
